import {query} from 'api';
import {withRouter, Redirect} from 'react-router';
import {branch, renderComponent, withProps} from 'recompose';
import BaseArticle from 'scenes/article/BaseArticle';
import PropTypes from 'prop-types';
import {Link} from 'ui';
import BaseRecipe from 'scenes/recipe/BaseRecipe';
import BaseConseil from 'scenes/conseil/BaseConseil';
import {Unsupported} from './styles';

// Contenu sans écran dans l'application : on propose de l'ouvrir sur le site.
const Post = ({data, location: {state: siteUrl}}) => {
  const url = siteUrl || data?.link;
  return (
    <Unsupported>
      Ce contenu ne s’affiche pas dans l’application.
      {url && (
        <>
          {' '}
          <Link href={url} target="_blank" rel="noopener noreferrer" data-external>
            Ouvrir sur le site
          </Link>
        </>
      )}
    </Unsupported>
  );
};

Post.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  location: PropTypes.object.isRequired,
};

const FormationRedirect = ({data}) => <Redirect to={`/formations/${data.id}`} />;

FormationRedirect.propTypes = {
  data: PropTypes.object.isRequired,
};

const isType =
  type =>
  ({data}) =>
    data?.type === type;

export default Post
  |> branch(isType('articles'), renderComponent(BaseArticle))
  |> branch(isType('recette_club'), renderComponent(BaseRecipe))
  |> branch(isType('conseils'), renderComponent(BaseConseil))
  |> branch(isType('formations'), renderComponent(FormationRedirect))
  |> query('getPostByPath', {loadingFullWidth: true}, ({path}) => `/${path}`)
  |> withProps(
    ({
      match: {
        params: {path},
      },
    }) => ({path: decodeURIComponent(path)}),
  )
  |> withRouter;
